export default {
  brand: '#E06436',
};



// WEBPACK FOOTER //
// ./src/utils/theme.js